module.exports = __webpack_public_path__ + "img/pencil.487a322c.png";